export const ignoreEvent = (event: Event) : void => {
    event.preventDefault()
    event.stopPropagation()
}
